// extracted by mini-css-extract-plugin
export default {"content":"deletefilemodal_content__3mIKp","Header":"deletefilemodal_Header__9h2io","subtitle":"deletefilemodal_subtitle__SbcWX"};